<template>
  <div>
    <!--操作栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <span class="tip">录入各存货的期初数量与金额，单价按“金额 ÷ 数量”自动计算</span>
      </Cell>
      <Cell>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </Cell>
    </Row>

    <!--期初表格-->
    <div class="h-panel-body padding-top">
      <Table :datas="rows" :border="true" :loading="loading">
        <TableItem title="#" prop="index" :width="55" align="center"></TableItem>
        <TableItem title="商品编码" prop="materialCode" :width="130"></TableItem>
        <TableItem title="商品名称" prop="materialName" :width="180"></TableItem>
        <TableItem title="规格型号" prop="materialSpec" :width="130"></TableItem>
        <TableItem title="计量单位" prop="unit" :width="90"></TableItem>
        <TableItem title="期初数量" :width="150">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.qty" @input="calcPrice(data)" style="width:100%">
          </template>
        </TableItem>
        <TableItem title="期初金额" :width="150">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.amount" @input="calcPrice(data)" style="width:100%">
          </template>
        </TableItem>
        <TableItem title="单价" :width="130" align="right">
          <template slot-scope="{data}">{{ money(data.price) }}</template>
        </TableItem>
        <TableItem title="状态" :width="90" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.status ? 'success' : 'default'">{{ data.status ? '已录入' : '未录入' }}</Tag>
          </template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryOpeningBalance',
  data() {
    return {
      rows: [],
      loading: false,
      saving: false
    };
  },
  methods: {
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.000000' : Number(n).toFixed(6);
    },
    calcPrice(data) {
      let q = Number(data.qty) || 0;
      let a = Number(data.amount) || 0;
      data.price = q > 0 ? (a / q).toFixed(6) : 0;
      data.status = q > 0 || a > 0 ? 1 : 0;
    },
    loadList() {
      this.loading = true;
      this.$api.pro.inventory.openingList().then(({data}) => {
        this.rows = data || [];
      }).finally(() => this.loading = false);
    },
    doSave() {
      let list = this.rows
        .filter(r => (Number(r.qty) > 0 || Number(r.amount) > 0))
        .map(r => ({
          id: r.id, materialId: r.materialId,
          qty: Number(r.qty) || 0, amount: Number(r.amount) || 0, price: r.price
        }));
      this.saving = true;
      this.$api.pro.inventory.openingSave(list).then(() => {
        this.$Message.success('期初数据保存成功');
        this.loadList();
      }).finally(() => this.saving = false);
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.tip {
  color: #888;
  font-size: 13px;
}
</style>
